export default __webpack_public_path__ + "static/Stickers-9e1dd27c879b763f64d0a422f7129d16.png";